import React, { Component, useState } from 'react';
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from '@react-google-maps/api';
import {
  APIHandler,
  BackButton,
  PremiumHotel,
  FreeHotel,
  StorageHandler,
} from 'C4';
import { baseAppId, storageKeys } from 'settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';

import { Multiselect } from 'multiselect-react-dropdown';

import SimpleBarReact from 'simplebar-react';
import 'simplebar/src/simplebar.css';

import MarkerFree from 'assets/images/ab-mapGrey.png';
import ClusterFree from 'assets/images/ab-mapClusterGrey.png';
import MarkerPremium from 'assets/images/ab-map.png';
import ClusterPremium from 'assets/images/ab-mapCluster.png';

const clusterPremium = {
  styles: [
    {
      url: ClusterPremium,
      width: 35,
      height: 51,
      textColor: 'white',
      textSize: 14,
      fontFamily: 'Source Sans Pro',
    },
  ],
  clusterClass: 'clusterIcon',
};

const clusterFree = {
  styles: [
    {
      url: ClusterFree,
      width: 35,
      height: 51,
      textColor: 'white',
      textSize: 14,
      fontFamily: 'Source Sans Pro',
    },
  ],
  clusterClass: 'clusterIcon',
};

const checkboxOptions = [
  {
    name: 'Ghost Towns',
    id: 'Ghost Towns',
    subcategories: [
      { name: 'Wildlife & Nature', id: 'Wildlife & Nature' },
      { name: 'Off-Roading & Adventure', id: 'Off-Roading & Adventure' },
    ],
  },
  { name: 'Weddings & Events', id: 'Weddings & Events' },
  { name: 'Weird Nevada', id: 'Weird Nevada' },
  {
    name: 'Museums',
    id: 'Museums',
    subcategories: [{ name: 'Local Art Scene', id: 'Local Art Scene' }],
  },
  {
    name: 'Outdoor Recreation',
    id: 'Outdoor Recreation',
    subcategories: [
      { name: 'Water Sports & Fishing', id: 'Water Sports & Fishing' },
      { name: 'Wildlife & Nature', id: 'Wildlife & Nature' },
      { name: 'Off-Roading & Adventure', id: 'Off-Roading & Adventure' },
      { name: 'Hiking & Trails', id: 'Hiking & Trails' },
    ],
  },
  {
    name: 'Shopping & Leisure',
    id: 'Shopping & Leisure',
    subcategories: [
      { name: 'Shopping', id: 'Shopping' },
      { name: 'Restaurants', id: 'Restaurants' },
      { name: 'Local Art Scene', id: 'Local Art Scene' },
      { name: 'Spa & Wellness', id: 'Spa & Wellness' },
    ],
  },
  {
    name: 'Food & Drink',
    id: 'Food & Drink',
    subcategories: [
      { name: 'Restaurants', id: 'Restaurants' },
      { name: 'Bars & Saloons', id: 'Bars & Saloons' },
      { name: 'Craft Beverages', id: 'Craft Beverages' },
    ],
  },
  {
    name: 'Accommodations',
    id: 'Accommodations',
    subcategories: [
      { name: 'Unique Stays', id: 'Unique Stays' },
      { name: 'RV Parks & Camping', id: 'RV Parks & Camping' },
      { name: 'Hotels & Lodging', id: 'Hotels & Lodging' },
      { name: 'Resorts & Casinos', id: 'Resorts & Casinos' },
    ],
  },
];

export default class DirectoryView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      premiumHotelsList: [],
      freeHotelsList: [],
      lat1: 51.46890852156073,
      lat2: 25.345783719711097,
      lon1: -110.21228574375,
      lon2: -124.31873105625,
      loading: false,
      query: '',
      allCategories: [],
      selectedCategory: '',
      selectedSubcategory: '',
      subcategoryOptions: [],
      width: null,
      mobile: false,
      source: false,
      showTopHeader: true,
      zoom: 6,
      center: {
        lat: 39.624113,
        lng: -117.2655084,
      },
      color: '0096bb',
      font: 'Source Sans Pro',
      userInfo: '',

      filterOpen: false,
      logo: null,
    };

    this.onSelect = this.onSelect.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    let mobile = false;
    if (params.get('mobile')) {
      mobile = true;
    }

    this.fetchCategories();

    if (width < 800) {
      this.getHotelsList();
    }

    if (params.get('source')) {
      this.setState({ source: JSON.parse(params.get('source')) });
    }

    let headerParam = JSON.parse(params.get('header'));
    let showTopHeader;
    if (headerParam === true) {
      showTopHeader = true;
    } else if (headerParam === false) {
      showTopHeader = false;
    } else {
      showTopHeader = !mobile;
    }
    console.log(showTopHeader, headerParam);

    this.setState({
      mobile,
      width,
      showTopHeader,
    });

    this.getLogo();
  }

  fetchCategories = () => {
    APIHandler.getCategories(1858).then((results) => {
      if (results && Array.isArray(results)) {
        this.setState({ allCategories: results });
      }
    });
  };

  handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;

    let subcategoryOptions = [];
    if (selectedCategory) {
      const match = checkboxOptions.find((opt) => opt.id === selectedCategory);
      if (match) {
        subcategoryOptions = match.subcategories || [];
      }
    }

    this.setState(
      {
        selectedCategory,
        selectedSubcategory: '',
        subcategoryOptions,
        category: selectedCategory ? [selectedCategory] : [],
      },
      () => {
        this.getHotelsList();
      },
    );
  };

  handleSubcategoryChange = (e) => {
    const selectedSubcategory = e.target.value;
    this.setState({ selectedSubcategory }, () => {
      this.getHotelsList();
    });
  };
  async getLogo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logoWideWhite ? appInfo.logoWideWhite : null,
      });
    }
  }

  handleInputChange = () => {
    this.setState(
      {
        query: this.search.value,
      },
      () => this.getHotelsList(),
    );
  };

  loadProperties(bounds, zoom) {
    this.setState(
      {
        lat1: bounds.getNorthEast().lat(),
        lat2: bounds.getSouthWest().lat(),
        lon1: bounds.getNorthEast().lng(),
        lon2: bounds.getSouthWest().lng(),
        zoom: zoom,
      },
      () => this.getHotelsList(),
    );
  }

  getHotelsList() {
    this.setState({ loading: true });
    setTimeout(() => {
      const {
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category,
        selectedSubcategory,
        width,
      } = this.state;
      // Without a map (narrow screens) there are no bounds to filter by
      const ignoreLocation = !(width > 700);
      const categoryHasComma =
        category && category.length === 1 && category[0].includes(',');
      const apiCategory = categoryHasComma ? [] : category;
      APIHandler.getFreeHotelsList(
        lat1,
        lat2,
        lon1,
        lon2,
        1858,
        query,
        apiCategory,
        selectedSubcategory,
        ignoreLocation,
      ).then((results) => {
        let filtered = Array.isArray(results) ? results : [];
        if (categoryHasComma) {
          filtered = filtered.filter((h) => h.category === category[0]);
        }
        this.setState({ freeHotelsList: filtered, loading: false });
      });
    }, 200);

    // App ID hardcoded until all are set in backend
    const { lat1, lat2, lon1, lon2, category } = this.state;

    // Convert to category + convert to array list
    let categoryArr = '';
    if (category?.length > 0) {
      category.forEach(function (e) {
        console.log(e);
        if (e == 'attraction') {
          e = 2;
        } else if (e == 'accommodation') {
          e = 1;
        } else if (e == 'CVB') {
          e = 7;
        }
        categoryArr += '&categoryArr[]' + '=' + e + '&';
      });
      console.log(categoryArr);
    }

    APIHandler.getPremiumHotelsList(
      lat1,
      lat2,
      lon1,
      lon2,
      859,
      categoryArr,
    ).then((results) => {
      // A failed request resolves to false or { ok: false }, never throw on it
      const items = results && Array.isArray(results.items) ? results.items : [];
      this.setState({ premiumHotelsList: items });
    });
  }
  flyToMarker = (lat, lon) => {
    this.setState({
      zoom: 15,
      center: {
        lat: Number(lat),
        lng: Number(lon),
      },
    });
  };

  resetMap = () => {
    this.setState({
      zoom: 6,
      center: {
        lat: 39.624113,
        lng: -117.2655084,
      },
    });
  };

  resetFilters = () => {
    window.location.reload(false);
  };

  premiumInfo = (userInfoID) => {
    if (this.state.mobile) {
      window.ReactNativeWebView?.postMessage(
        `webview:https://travproconnect.com/profile/${userInfoID}?app_id=${baseAppId}&mobile=true`,
      );
    } else {
      document.getElementById('iframe').classList.remove('hide');
      this.setState({
        userInfo: `https://travproconnect.com/profile/${userInfoID}?app_id=${baseAppId}`,
      });
    }
  };

  freeInfo = (userInfoID) => {
    if (this.state.mobile) {
      window.ReactNativeWebView?.postMessage(
        `webview:https://cms.travpromobile.com/api/listing/detail?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10&mobile=true`,
      );
    } else {
      document.getElementById('iframe').classList.remove('hide');
      this.setState({
        userInfo: `https://cms.travpromobile.com/api/listing/detail?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
      });
    }
  };

  onSelect(selectedList, selectedItem) {
    this.setState(
      {
        [selectedItem.id]: [
          ...this.state[selectedItem.id],
          selectedItem['name'],
        ],
      },
      () => {
        this.getHotelsList();
      },
    );
  }

  onRemove(selectedList, removedItem) {
    const array = [...this.state[removedItem.id]];
    const index = array.indexOf(removedItem['name']);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState(
        {
          [removedItem.id]: array,
        },
        () => {
          this.getHotelsList();
        },
      );
    }
  }

  handleCheck = (e) => {
    if (this.state.category.includes(e.target.id)) {
      let filteredArray = this.state.category.filter(
        (item) => item !== e.target.id,
      );
      this.setState(
        {
          category: filteredArray,
        },
        () => {
          this.getHotelsList();
        },
      );
    } else {
      if (e.target.id !== '') {
        this.setState(
          {
            category: this.state.category.concat([e.target.id]),
          },
          () => {
            this.getHotelsList();
          },
        );
      }
    }
  };

  closeIframe() {
    document.getElementById('iframe').classList.add('hide');
  }

  toggleFilter = () => {
    this.setState({
      filterOpen: !this.state.filterOpen,
    });
  };

  render() {
    const {
      premiumHotelsList,
      freeHotelsList,
      zoom,
      center,
      userInfo,
      mobile,
      source,
      showTopHeader,
      width,
      loading,
      filterOpen,
      logo,
      selectedCategory,
      selectedSubcategory,
      subcategoryOptions,
    } = this.state;

    const hideCookieConsent = mobile || source;
    const mapContainerStyle = mobile
      ? { width: '100%', height: '100vh' }
      : { width: '100%', height: '100%' };

    const directoryRootClass = [
      'directoryContainer',
      !showTopHeader && 'directoryContainer--noTopHeader',
    ]
      .filter(Boolean)
      .join(' ');

    const searchBar = (
      <div className="directoryListSearch">
        <div className="search">
          <FontAwesomeIcon icon={['fas', 'search']} className="searchIcon" />
          <input
            className="searchInput"
            placeholder={i18n.translate('nav.search')}
            type="text"
            ref={(input) => (this.search = input)}
            onChange={this.handleInputChange}
          />
        </div>
      </div>
    );
    return (
      <div className={directoryRootClass}>
        {hideCookieConsent && (
          <style>{'.cookieConsent { display: none !important; }'}</style>
        )}
        {showTopHeader && (
          <div className="header">
            <BackButton useHistory={false} text="Back" />
            <img src={logo} className="logo" alt="logo" />
          </div>
        )}
        <div className="directoryView">
          <div className="leftSide">
            <div className={`filterContainer ${filterOpen ? 'active' : ''}`}>
              <div className="type">
                <Multiselect
                  options={this.state.options}
                  selectedValues={this.state.selectedValue}
                  onSelect={this.onSelect}
                  onRemove={this.onRemove}
                  displayValue="name"
                  placeholder="Filter by Category"
                  showArrow={true}
                  avoidHighlightFirstOption={true}
                />
              </div>
              <div className="island">
                <Multiselect
                  options={this.state.islandOptions}
                  selectedValues={this.state.selectedValue}
                  onSelect={this.onSelect}
                  onRemove={this.onRemove}
                  displayValue="name"
                  placeholder="Filter by Island"
                  showArrow={true}
                  avoidHighlightFirstOption={true}
                />
              </div>
              <div className="price">
                <Multiselect
                  options={this.state.priceOptions}
                  selectedValues={this.state.selectedValue}
                  onSelect={this.onSelect}
                  onRemove={this.onRemove}
                  displayValue="name"
                  placeholder="Filter by Price"
                  showArrow={true}
                  avoidHighlightFirstOption={true}
                />
              </div>
              <div className="checkboxOptions">
                <span className="title">
                  {i18n.translate('directory.filters')}:
                </span>
                <div className="filterDropdown">
                  <select
                    id="categorySelect"
                    value={selectedCategory}
                    onChange={this.handleCategoryChange}
                  >
                    <option value="">
                      {i18n.translate('directory.filters')}
                    </option>
                    {checkboxOptions
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((opt, index) => (
                        <option key={index} value={opt.id}>
                          {opt.name}
                        </option>
                      ))}
                  </select>
                </div>
                {selectedCategory && !!subcategoryOptions.length && (
                  <div className="filterDropdown">
                    <select
                      id="subcategorySelect"
                      value={selectedSubcategory}
                      onChange={this.handleSubcategoryChange}
                    >
                      <option value="">
                        {i18n.translate('directory.subFilter')}
                      </option>
                      {subcategoryOptions
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((sub, index) => (
                          <option key={index} value={sub.id}>
                            {sub.name}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
              </div>

              <div className="text-center">
                <button
                  onClick={this.resetFilters}
                  className="filter-btn inverted"
                >
                  {i18n.translate('directory.reset')}
                </button>
                <button onClick={this.toggleFilter} className="show-results">
                  {i18n.translate('general.submit')}
                </button>
              </div>
            </div>

            <div className="results">
              {i18n.translate('directory.amount')}:{' '}
              {freeHotelsList.length + premiumHotelsList.length}
              <button
                onClick={filterOpen ? this.toggleFilter : this.toggleFilter}
                className="filter-btn"
              >
                {filterOpen
                  ? i18n.translate('directory.open')
                  : i18n.translate('directory.filter')}
              </button>
            </div>
            <div className="leftGrid">
              <div className="listColumn">
                {searchBar}
                <SimpleBarReact
                  className={`listContainer ${filterOpen ? 'filterOpen' : ''}`}
                >
                  <div className="premiumList">
                    {loading && (
                      <span className="loader">
                        <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
                      </span>
                    )}
                    {premiumHotelsList.length > 0 &&
                      premiumHotelsList.map((hotel) => (
                        <PremiumHotel
                          key={hotel.id}
                          id={hotel.id}
                          bgImage={hotel.headerImages[0]}
                          propertyName={hotel.propertyName}
                          flyToMarker={() => {
                            this.flyToMarker(
                              hotel.coords.latitude,
                              hotel.coords.longitude,
                            );
                          }}
                          hotelInfo={() => {
                            this.premiumInfo(hotel.userInfoID);
                          }}
                        />
                      ))}
                  </div>
                  <div className="freeList">
                    {freeHotelsList.length === 0 && !loading && (
                      <div className="noResults">
                        {i18n.translate('general.noResultsFor')}
                      </div>
                    )}
                    {freeHotelsList.length > 0 &&
                      freeHotelsList.map((hotel) => (
                        <FreeHotel
                          key={hotel.company_listing_id}
                          id={hotel.company_listing_id}
                          bgImage={hotel.img_path}
                          flyToMarker={() => {
                            this.flyToMarker(hotel.latitude, hotel.longitude);
                          }}
                          hotelInfo={() => {
                            this.freeInfo(hotel.listing_id);
                          }}
                          hotelName={hotel.company}
                          category={hotel.category}
                          location={hotel.state}
                          item={hotel}
                        />
                      ))}
                    {zoom > 8 && (
                      <div
                        className="resetMap"
                        onClick={() => {
                          this.resetMap();
                        }}
                      >
                        {i18n.translate('directory.reset')}
                      </div>
                    )}
                  </div>
                </SimpleBarReact>
              </div>
            </div>
          </div>
          {width > 700 && (
            <div className="rightSide">
              <LoadScript googleMapsApiKey="AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc">
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={center}
                  zoom={zoom}
                  onLoad={(map) => {
                    this.map = map;
                  }}
                  onIdle={() => {
                    this.loadProperties(
                      this.map.getBounds(),
                      this.map.getZoom(),
                    );
                  }}
                >
                  {/* Child components, such as markers, info windows, etc. */}
                  <MarkerClusterer
                    minimumClusterSize={4}
                    gridSize={100}
                    options={clusterFree}
                  >
                    {(clusterer) => {
                      return (
                        freeHotelsList.length > 0 &&
                        freeHotelsList.map((freeHotel) => (
                          <Marker
                            key={freeHotel.listing_id}
                            position={{
                              lat: Number(freeHotel.latitude),
                              lng: Number(freeHotel.longitude),
                            }}
                            icon={MarkerFree}
                            onClick={() => {
                              this.flyToMarker(
                                freeHotel.latitude,
                                freeHotel.longitude,
                              );
                            }}
                            clusterer={clusterer}
                          />
                        ))
                      );
                    }}
                  </MarkerClusterer>
                  <MarkerClusterer
                    minimumClusterSize={5}
                    options={clusterPremium}
                  >
                    {(clusterer) => {
                      return (
                        premiumHotelsList.length > 0 &&
                        premiumHotelsList.map((premiumHotel) => (
                          <Marker
                            key={premiumHotel.id}
                            position={{
                              lat: premiumHotel.coords.latitude,
                              lng: premiumHotel.coords.longitude,
                            }}
                            icon={MarkerPremium}
                            onClick={() => {
                              this.flyToMarker(
                                premiumHotel.coords.latitude,
                                premiumHotel.coords.longitude,
                              );
                            }}
                            clusterer={clusterer}
                          ></Marker>
                        ))
                      );
                    }}
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>

              <div className={`filterContainer ${filterOpen ? 'active' : ''}`}>
                <div className="dropdownFilters">
                  <div className="filterDropdown">
                    <select
                      id="categorySelect"
                      value={selectedCategory}
                      onChange={this.handleCategoryChange}
                    >
                      <option value="">
                        {i18n.translate('directory.filters')}
                      </option>
                      {checkboxOptions
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((opt, index) => (
                          <option key={index} value={opt.id}>
                            {opt.name}
                          </option>
                        ))}
                    </select>
                  </div>
                  {selectedCategory && !!subcategoryOptions.length && (
                    <div className="filterDropdown">
                      <select
                        id="subcategorySelect"
                        value={selectedSubcategory}
                        onChange={this.handleSubcategoryChange}
                      >
                        <option value="">
                          {i18n.translate('directory.subFilter')}
                        </option>
                        {subcategoryOptions
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((sub, index) => (
                            <option key={index} value={sub.id}>
                              {sub.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}
                </div>
                <div
                  className="resetFilters"
                  onClick={() => {
                    this.resetFilters();
                  }}
                >
                  {i18n.translate('directory.reset')}
                </div>
                <div className="text-center">
                  <button
                    onClick={this.resetFilters}
                    className="filter-btn inverted"
                  >
                    {i18n.translate('directory.reset')}
                  </button>
                  <button onClick={this.toggleFilter} className="show-results">
                    {i18n.translate('general.submit')}
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="iframe hide" id="iframe">
            <div
              className="bgIframe"
              onClick={() => {
                this.closeIframe();
              }}
            ></div>
            <div className="iframeHolder">
              <div
                className="closeIframe"
                href="#"
                onClick={() => {
                  this.closeIframe();
                }}
              >
                <span className="closeText">
                  <FontAwesomeIcon icon={['fas', 'chevron-left']} />{' '}
                  {i18n.translate('general.back')}
                </span>
              </div>
              <div className="contentIframe">
                <iframe
                  width="100%"
                  height="100%"
                  id="iframeModal"
                  src={userInfo}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
